import { PaymentProvider, PaymentProviderLabel } from "../../../../config/payment_providers";

interface IExtraPaidViaProps {
    value: PaymentProvider;
}

export const ExtraPaidVia = ({value}: IExtraPaidViaProps) => PaymentProviderLabel[value];
